module.exports = __webpack_public_path__ + "media/images/caixa-1aa940e41eb6cadf164659f0d9efde82.svg";